import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "branninger_auth_token";

export const getToken = () => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token) => {
  if (typeof window === "undefined") return;
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const clearToken = () => setToken(null);

// Public client (no auth)
export const api = axios.create({ baseURL: API });

// Authenticated client — attaches Bearer token from localStorage at call time
export const authApi = () => {
  const token = getToken();
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// Kept for legacy callers — now wraps authApi (token replaces the X-Admin-Key)
export const adminApi = () => authApi();

// Build a full URL for a stored file (the backend returns relative `/api/files/...`)
export const fileUrl = (urlOrPath) => {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http")) return urlOrPath;
  if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
  return `${API}/files/${urlOrPath}`;
};
